import TagComponent from 'components/Tags';
import { StakeholderStatus as StakeholderStatusType } from 'types/common';
import { getStakeholderStatus } from '../helper';

const StakeholderStatus = ({
  status,
  style,
}: {
  status: StakeholderStatusType;
  style?: React.CSSProperties;
}) => {
  if (!status) return 'N/A';

  const stakeHolderStatus = getStakeholderStatus(status);

  return (
    <TagComponent
      label={stakeHolderStatus.label}
      style={{
        color: stakeHolderStatus.color,
        backgroundColor: stakeHolderStatus.statusColor,
        width: 'fit-content',
        ...style,
      }}
    />
  );
};

export default StakeholderStatus;
